import { waitForElementInViewOnce } from '@helpers/functions';

class ImageText {
  element: HTMLElement;
  observer?: IntersectionObserver;

  constructor(element: HTMLElement) {
    this.element = element;
  }

  init() {
    const imageContainers = this.element.querySelectorAll<HTMLElement>('.kf-o-image-text__image');

    imageContainers.forEach((item) => {
      waitForElementInViewOnce(item)
        .then((entry) => {
          if (entry.isIntersecting && !item.classList.contains('show')) {
            const imageElement = entry.target.querySelector('img');

            if (imageElement?.complete) {
              entry.target.classList.add('show');

              return;
            }

            imageElement?.addEventListener('load', () => {
              entry.target.classList.add('show');
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const imageTextElements = document.querySelectorAll<HTMLElement>('.kf-o-image-text');

  imageTextElements.forEach((element) => {
    new ImageText(element).init();
  });
});

export { ImageText };
